/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profileneworganizer2Inputs */

const en_profileneworganizer2 = /** @type {(inputs: Profileneworganizer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New organizer`)
};

const de_profileneworganizer2 = /** @type {(inputs: Profileneworganizer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Veranstalter`)
};

/**
* | output |
* | --- |
* | "New organizer" |
*
* @param {Profileneworganizer2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profileneworganizer2 = /** @type {((inputs?: Profileneworganizer2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profileneworganizer2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profileneworganizer2(inputs)
	return de_profileneworganizer2(inputs)
});
export { profileneworganizer2 as "profileNewOrganizer" }